import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-760fb89a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#d8f2df","min-height":"86vh"} }
const _hoisted_2 = { class: "w-full max-w-4xl mx-auto px-4 py-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-primary-2 font-semibold my-8 px-6 text-56px lg-text-72px" }, " Gracious Donors ", -1))
const _hoisted_4 = { class: "my-6 flex flex-wrap lg:justify-between items-center justify-center" }
const _hoisted_5 = { class: "bg-white rounded-full overflow-hidden flex items-center px-4" }
const _hoisted_6 = { class: "lg:mt-0 mt-4 w-auto mx-auto flex justify-center px-1 py-1 bg-white rounded-full overflow-hidden" }
const _hoisted_7 = { class: "wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "my-52 text-center text-3xl text-gray-500"
}
const _hoisted_9 = {
  key: 1,
  class: "my-8"
}
const _hoisted_10 = { class: "w-full max-w-2xl mx-auto" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "lg:flex-1 truncate w-full" }
const _hoisted_13 = { class: "text-16px lg-text-24px truncate" }
const _hoisted_14 = { class: "text-gray-500 text-xs w-60 md:(w-full ) lg:text-sm truncate" }
const _hoisted_15 = {
  class: "ml-auto whitespace-nowrap bg-primary-2 rounded-full px-4 py-2 font-semibold text-white text-12px lg-text-28px",
  style: {"width":"fit-content"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_17 = {
  key: 2,
  class: "mt-8 mb-16"
}
const _hoisted_18 = { class: "flex justify-center" }
const _hoisted_19 = { class: "flex px-6 self-center items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Page", -1))
const _hoisted_21 = ["onKeydown"]

import { watch, onMounted, ref } from 'vue';
import { Icon } from '@iconify/vue';
import { numberWithCommas } from '@/composables/format';

import useMoralis from '@/composables/useMoralis';
import { GetDonor } from '@/types/MoralisCloud';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const moralis = useMoralis();

const loading = ref<boolean>(false);
const q = ref<string>('');
const curentPage = ref<number>(1);
const pageInfo = ref({ page: 1, last_page: 0 });

const isGDMostRecent = ref<boolean>(true);
const gds = ref();
const fetchGD = async () => {
  if (loading.value) return;

  loading.value = true;
  const result = await moralis.currect.Cloud.run<GetDonor>('getDonors', {
    email: q.value || undefined,
    reverse: 'true',
    sort: isGDMostRecent.value ? 'blockTimestamp' : 'nftAmount',
    page: curentPage.value,
    size: 10,
  });
  gds.value = result.entities;
  pageInfo.value = {
    page: result.pageInfo.page || 1,
    last_page: result.pageInfo.totalPage || 0,
  };
  curentPage.value = result.pageInfo.page || 1;
  loading.value = false;
};

const getDateTime = (date: string) => {
  const d = new Date(date);
  const mL = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return `${d.getDate()} ${
    mL[d.getMonth()]
  } ${d.getFullYear()}, ${d.getHours()}:${d.getMinutes()} ${
    d.getHours() >= 12 ? 'PM' : 'AM'
  }`;
};

watch(q, () => {
  curentPage.value = 1;
  fetchGD();
});
watch(isGDMostRecent, () => {
  curentPage.value = 1;
  fetchGD();
});

onMounted(async () => {
  fetchGD();
});

const changePage = (i: number) => {
  if (curentPage.value > 1 && i === -1) {
    curentPage.value = curentPage.value + i;
  }

  if (curentPage.value < pageInfo.value.last_page && i === 1) {
    curentPage.value = curentPage.value + i;
  }

  fetchGD();
};

return (_ctx: any,_cache: any) => {
  const _component_BaseEmpty = _resolveComponent("BaseEmpty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Icon), {
              icon: "bx:bx-search",
              class: "text-2xl"
            }),
            _withDirectives(_createElementVNode("input", {
              class: "focus:outline-none",
              placeholder: "Donor search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((q).value = $event))
            }, null, 512), [
              [_vModelText, q.value]
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["taeb-switch text-center", { left: isGDMostRecent.value, right: !isGDMostRecent.value }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["taeb", {
                    'text-white active': isGDMostRecent.value,
                    'text-primary-2': !isGDMostRecent.value,
                  }]),
                  "taeb-direction": "left",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isGDMostRecent.value = true))
                }, " Most Recent ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["taeb", {
                    'text-white active': !isGDMostRecent.value,
                    'text-primary-2': isGDMostRecent.value,
                  }]),
                  "taeb-direction": "right",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isGDMostRecent.value = false))
                }, " Most Forest ", 2)
              ], 2)
            ])
          ])
        ])
      ]),
      (gds.value?.length <= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_BaseEmpty, {
              src: require('@/assets/svg/empty-search.svg'),
              class: "flex-1",
              title: "No results found."
            }, null, 8, ["src"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gds.value, (gd, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "my-4 px-2 py-2 rounded-3xl lg:rounded-full bg-white overflow-hidden flex space-x-4 items-center justify-between",
                  key: `gd-${i}`
                }, [
                  _createElementVNode("img", {
                    src: 
                gd.nftAmount <= 50
                  ? '/images/gd/gd-feed.svg'
                  : gd.nftAmount <= 100
                  ? '/images/gd/gd-reaf.svg'
                  : gd.nftAmount <= 1000
                  ? '/images/gd/gd-flower.svg'
                  : gd.nftAmount <= 10000
                  ? '/images/gd/gd-seedling.svg'
                  : gd.nftAmount <= 50000
                  ? '/images/gd/gd-tree.svg'
                  : gd.nftAmount <= 100000
                  ? '/images/gd/gd-forest.svg'
                  : '/images/gd/gd-world.svg'
              ,
                    class: "w-12 h-12 p-2 bg-primary-2 rounded-full",
                    alt: ""
                  }, null, 8, _hoisted_11),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(gd.email), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(getDateTime(gd.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_unref(numberWithCommas)(gd.nftAmount)) + " ft", 1),
                    _hoisted_16
                  ])
                ]))
              }), 128))
            ])
          ])),
      (pageInfo.value.last_page > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "page--btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (changePage(-1)))
              }, [
                _createVNode(_unref(Icon), {
                  class: "icon",
                  icon: "bi:chevron-left"
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  class: "flex items-center mx-3 text-center h-10 rounded border w-20 justify-center bg-white",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((curentPage).value = $event)),
                  onKeydown: _withKeys(fetchGD, ["enter"]),
                  onBlur: fetchGD
                }, null, 40, _hoisted_21), [
                  [_vModelText, curentPage.value]
                ]),
                _createElementVNode("span", null, "of " + _toDisplayString(pageInfo.value.last_page), 1)
              ]),
              _createElementVNode("div", {
                class: "page--btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (changePage(1)))
              }, [
                _createVNode(_unref(Icon), {
                  class: "icon",
                  icon: "bi:chevron-right"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})